import { Button } from "@/components/flexkit/Button";
import { useTriggerPrebuild } from "@/hooks/use-trigger-prebuild.tsx";
import { type FC } from "react";

type TriggerPrebuildButtonProps = {
    projectId: string;
    environmentClassIds: string[];
    prebuildsEnabled?: boolean;
};

export const TriggerPrebuildButton: FC<TriggerPrebuildButtonProps> = ({
    projectId,
    environmentClassIds,
    prebuildsEnabled,
}) => {
    const { trigger, isSubmitting } = useTriggerPrebuild(projectId, environmentClassIds, prebuildsEnabled);

    return (
        <Button
            variant="secondary"
            size="sm"
            onClick={trigger}
            loading={isSubmitting}
            data-testid="trigger-prebuild-button"
            data-tracking-id="trigger-prebuild-button"
        >
            Prebuild
        </Button>
    );
};
